<template>
  <div
    class="c-header o-grid o-grid--direction-row o-grid--wrap-nowrap o-wrap--padding-side-default o-grid--align-items-center"
  >
    <div class="o-grid__group">
      <div class="o-grid__item">
        <svg
          class="c-header__logo o-svg-icon"
          viewBox="0 0 220 45"
          type="image/svg+xml"
        >
          <use
            xlink:href="spritemap.svg#sprite-logo-invertedhjeva"
            x="0"
            y="0"
          ></use>
        </svg>
      </div>
      <div class="o-grid__item" v-if="loggedIn">
        <div class="o-grid o-grid--justify-content-end o-grid--gutter-normal">
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--grow-0">
              <div
                class="o-grid o-grid--justify-content-end o-grid--gutter-normal"
              >
                <div class="o-grid__group">
                  <div class="o-grid__item o-grid__item--grow-0">
                    <router-link
                      class="c-header__item navigation-item"
                      to="/home"
                    >
                      {{ headerTranslations.home }}
                    </router-link>
                  </div>
                  <div class="o-grid__item o-grid__item--grow-0">
                    <router-link
                      class="c-header__item navigation-item"
                      to="/administer"
                    >
                      {{ headerTranslations.administer }}
                    </router-link>
                  </div>
                  <div class="o-grid__item o-grid__item--grow-0">
                    <router-link
                      class="c-header__item navigation-item"
                      to="/tip-os"
                      target="_blank"
                    >
                      {{ headerTranslations.tipOs }}
                    </router-link>
                  </div>
                  <div class="o-grid__item o-grid__item--grow-0">
                    <a
                      class="c-header__item navigation-item"
                      href="http://hjertestarterbranche.dk/?page_id=46"
                      target="blank"
                      >Brancheforeningen</a
                    >
                  </div>
                  <div class="o-grid__item o-grid__item--grow-0">
                    <a
                      class="c-header__item navigation-item"
                      href="https://hjertestarter.dk/"
                      target="blank"
                      >Hjertestarter.dk</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="o-grid__item o-grid__item--grow-0">
              <div class="c-header__separator"></div>
            </div>
            <div class="o-grid__item o-grid__item--grow-0">
              <div
                class="o-grid o-grid--justify-content-end o-grid--gutter-small"
              >
                <div class="o-grid__group">
                  <div
                    class="o-grid__item o-grid__item--grow-0"
                    v-if="loggedIn"
                  >
                    <span class="c-header__item c-header__item--user">{{
                      userInfo.givenName
                    }}</span>
                  </div>
                  <div class="o-grid__item o-grid__item--grow-0">
                    <router-link
                      class="c-header__item c-header__item--logout"
                      to="/"
                    >
                      {{ headerTranslations.logout }}</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "c-header",
  data() {
    return {};
  },
  props: {},
  computed: {
    ...mapState("authentication", ["userInfo"]),
    ...mapState("translations", {
      headerTranslations: "header"
    }),
    loggedIn() {
      return this.$store.state.authentication.status.loggedIn;
    },
    user() {
      return this.$store.state.authentication.userInfo;
    }
  }
};
</script>
<style lang="scss">
.c-header {
  position: relative;
  background-color: $s-cp-sup-red;
  min-height: toRem(80px);
  z-index: z("header");

  &__item {
    width: auto;
    @include setStyles("15", $s-typography-sizes);
    font-weight: 700;
    color: $s-cp-neutral-white;
    text-decoration: none;
    display: block;

    &--user {
      font-weight: 500;
    }
    &--logout {
      @include setStyles("14", $s-typography-sizes);
    }
    &.navigation-item.router-link-active {
      position: relative;
      &:before {
        content: "";
        display: block;
        background-color: $s-cp-neutral-white;
        opacity: 0.25;
        width: 130%;
        height: 130%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
        min-height: 30px;
      }
    }
  }

  &__logo {
    height: toRem(40px);
  }
  &__links {
    width: auto;
    height: 100%;
  }
  &__separator {
    width: toRem(1px);
    background: $s-cp-neutral-white;
    display: block;
    height: toRem(30px);
    opacity: 0.5;
  }
}
</style>
